import Resource from '@/api/resources/Resource'
import { CASE_SITUATIONS } from '@/modules/diagnosisModule/services/caseSituations'

class DashboardService extends Resource {
    async getSummaryCaseSituations(filterModel) {
        return this.axios.put(`/diagnosis/cases/summaryBySituations`, filterModel).then(response => response.data)
    }
    async getSummaryCaseDelayed(caseSituation, filterModel, relativeHourIntervals, caseDelaySummaryEnum) {
        let params = {
            caseSituation: caseSituation,
            caseDelaySummaryEnum: caseDelaySummaryEnum
        }
        let request = {
            filterModel: filterModel,
            relativeHourIntervals: relativeHourIntervals
        }
        return this.axios.put(`/diagnosis/cases/summaryDelay`, request, { params }).then(response => response.data)
    }
    async getSummaryCaseByCaseType(caseSituation, filterModel) {
        let params = {
            caseSituation: caseSituation
        }
        return this.axios.put(`/diagnosis/cases/summaryByCaseType`, filterModel, { params }).then(response => response.data)
    }
    async getSummaryCaseByPriority(caseSituation, filterModel) {
        let params = {
            caseSituation: caseSituation
        }
        return this.axios.put(`/diagnosis/cases/summaryByPriority`, filterModel, { params }).then(response => response.data)
    }
    async getSummaryOfUnseenRequests() {
        const response = await this.axios.get(`/clinical/requests/unseen/summary`)
        return response.data
    }
    async getSummaryOfLockedRequests() {
        const response = await this.axios.get(`/clinical/requests/locked/summary`)
        return response.data
    }
    async getSummaryOfRequestedRequests(laboratoryId) {
        const response = await this.axios.get(`/registry/laboratories/${laboratoryId}/requests/requested/summary`)
        return response.data
    }
    async getSummaryOfRegisteredTodayCases(laboratoryId) {
        const response = await this.axios.get(`/registry/laboratories/${laboratoryId}/cases/registeredToday/summary`)
        return response.data
    }
    async getSummaryOfRegistryLockedRequests(laboratoryId) {
        const response = await this.axios.get(`/registry/laboratories/${laboratoryId}/requests/locked/summary`)
        return response.data
    }
    async getSummaryOfSamplesPendingProcessing(laboratoryId) {
        const response = await this.axios.get(`/grossing/laboratories/${laboratoryId}/cases/samples/pendingProcessing/summary`)
        return response.data
    }
    async getSummaryOfSamplesPendingReProcessing(laboratoryId) {
        const response = await this.axios.get(`/grossing/laboratories/${laboratoryId}/cases/samples/pendingReprocessing/summary`)
        return response.data
    }
    async getSummaryOfProcessedTodaySamples(laboratoryId) {
        const response = await this.axios.get(`/grossing/laboratories/${laboratoryId}/cases/samples/processedToday/summary`)
        return response.data
    }
    async getSummaryOfPortionsPendingCut(laboratoryId) {
        const response = await this.axios.get(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/pendingCut/summary`)
        return response.data
    }
    async getSummaryOfPortionsPendingMake(laboratoryId) {
        const response = await this.axios.get(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/pendingMake/summary`)
        return response.data
    }
    async getSummaryOfSubPortionsPendingScan(laboratoryId) {
        const response = await this.axios.get(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/subportions/pendingToScanner/summary`)
        return response.data
    }
    async getSummaryOfSamplesDisposedToday(laboratoryId) {
        const response = await this.axios.get(`/waste/laboratories/${laboratoryId}/samples/disposedToday/summary`)
        return response.data
    }
    async getSummaryOfSamplesPendingDisposal(laboratoryId) {
        const response = await this.axios.get(`/waste/laboratories/${laboratoryId}/samples/pendingDisposal/summary`)
        return response.data
    }
    async getSummaryOfOpenIncidentsByLoggedInUser(laboratoryId) {
        const response = await this.axios.get(`/incident/laboratories/${laboratoryId}/incidents/open/summary`)
        return response.data
    }
}
export default new DashboardService()

export const DASHBOARD_SITUATION_CASE_OPTIONS = {
    PENDING_INFORM: { key: CASE_SITUATIONS.PENDING_INFORM, label: 'diagnosis.sidebar.pendingInform', bgColor: '#E5FFDE' },
    PENDING_TRANSCRIPTION: { key: CASE_SITUATIONS.PENDING_TRANSCRIPTION, label: 'diagnosis.sidebar.pendingTranscription', bgColor: '#18020C' },
    PENDING_VALIDATION: { key: CASE_SITUATIONS.PENDING_VALIDATION, label: 'diagnosis.sidebar.pendingValidation', bgColor: '#004FFF' },
    PENDING_ADDITIONAL_ASSAYS: { key: CASE_SITUATIONS.PENDING_ADDITIONAL_ASSAYS, label: 'diagnosis.sidebar.pendingAdditionalAssays', bgColor: '#CA5310' },
    PENDING_COMPLEMENTARY: { key: CASE_SITUATIONS.PENDING_COMPLEMENTARY, label: 'diagnosis.sidebar.pendingComplementary', bgColor: '#FFD5FF' },
    PENDING_AMENDMENT: { key: CASE_SITUATIONS.PENDING_AMENDMENT, label: 'diagnosis.sidebar.pendingAmendment', bgColor: '#474787' },
    ALL_PENDING_DASHBOARD: { key: CASE_SITUATIONS.ALL_PENDING_DASHBOARD, label: 'diagnosis.sidebar.pendingAll', bgColor: '#CA5310' }
}

export const CASE_DELAYED_SCOPE = {
    GLOBAL: 'GLOBAL',
    DIAGNOSIS: 'DIAGNOSIS'
}
